import { useState, useEffect } from 'react'

export default function BlogSearch({ query, onChange }) {
  const [localQuery, setLocalQuery] = useState(query)

  // Debounce the search input
  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(localQuery)
    }, 300)

    return () => clearTimeout(timer)
  }, [localQuery, onChange])

  // Sync with external query changes
  useEffect(() => {
    setLocalQuery(query)
  }, [query])

  return (
    <div className="blog-search-wrapper">
      <svg
        className="blog-search-icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35" />
      </svg>

      <input
        type="text"
        className="blog-search-input"
        placeholder="Search articles..."
        value={localQuery}
        onChange={(e) => setLocalQuery(e.target.value)}
      />

      {localQuery && (
        <button
          className="blog-search-clear"
          onClick={() => {
            setLocalQuery('')
            onChange('')
          }}
          aria-label="Clear search"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      )}
    </div>
  )
}
